module.exports = __webpack_public_path__ + "img/logo-light.38235d72.png";